import UpdatePromo from './UpdatePromo'
export default UpdatePromo
